<template>
    <el-dialog
		:title="`批量添加${title}`"
		:visible.sync="batchAddshow" 
		:close-on-click-modal="false"
    >
		<span>每行代表一个{{title}}，可以添加多个{{title}}</span>
		<el-input
		style="margin-top: 10px"
		type="textarea"
		:rows="8"
		:placeholder="placeholder || `${title}1`"
		v-model="addBatch"
		resize="none"
    >
		</el-input>
		<span slot="footer" class="dialog-footer">
		<el-button @click="cancelAdd">取 消</el-button>
		<el-button 
			type="primary" 
			@click="batchAdd"
			:loading="loading"
		>确 定</el-button>
		</span>
    </el-dialog>
</template>

<script>
export default {
	// 批量添加选项、行、列
    name: 'BatchAddOption',
    props: {
        title: {
            type: String,
            default: ''
        },
        functionName: {
            type: String,
            default: ''
        },
		question: {
            type: Object,
            default: () => {
				return {}
			}
        },
    },
    data() {
        return {
            batchAddshow: false,
            addBatch: '',
			loading: false,
			placeholder: '',
			defaultOptionList: []
        }
    },
	created() {
		
		this.getdefaultQuesIdAndName()
	},
    methods: {
		// 筛选出默认的选项名和id
		getdefaultQuesIdAndName() {
			if (this.question?.qid && this.functionName == 'batchAdd'){
				// 筛选出默认的选项名和id
				this.question?.optionList.forEach((info) => {
					if (info.isDefault) {
						this.defaultOptionList.push(info.oid)
						this.placeholder = this.placeholder ? `${this.placeholder}\n${info.labelName}` : info.labelName
					}
				})
			} else if (this.question?.qid && this.functionName == 'batchAddRows'){
				// 筛选出默认的选项名和id
				this.question?.questionsSonList.forEach((info) => {
					if (info.isDefault) {
						this.defaultOptionList.push(info.SonId)
						this.placeholder = this.placeholder ? `${this.placeholder}\n${info.questionsName}` : info.questionsName
					}
				})
				// console.log(this.question?.questionsSonList)
			} else if (this.question?.qid && this.functionName == 'batchAddColumns'){
				// 筛选出默认的选项名和id
				this.question?.questionsSonList[0]?.optionList.forEach((info) => {
					if (info.isDefault) {
						this.defaultOptionList.push(info.oid)
						this.placeholder = this.placeholder ? `${this.placeholder}\n${info.labelName}` : info.labelName
					}
				})
			}
		},
		cancelAdd(){
			this.addBatch = ''
			this.batchAddshow = false
			this.loading = false
			this.defaultOptionList = []
			this.placeholder = ''
		},
		batchAdd() {
			this.loading = true
			let optionArr = this.addBatch.split('\n').filter((info) => info)
			this.$emit(this.functionName, optionArr);
			this.delOption()
			this.cancelAdd()
		},
		delOption(){
			if (this.defaultOptionList.length > 0) {
				switch(this.functionName){
					case 'batchAdd':  // 删除选项
						this.question.optionList = this.question.optionList.filter((info => !info.isDefault))
						break
					case 'batchAddRows':  // 删除行
						this.question.questionsSonList = this.question.questionsSonList.filter((info => !info.isDefault))
						console.log(this.question.questionsSonList)
						break
					case 'batchAddColumns':  // 删除列
						this.question.questionsSonList.forEach((son) => {
							son.optionList = son.optionList.filter((info => !info.isDefault))
						})
						break
				}
			}
		}
    }
}
</script>